import { render, staticRenderFns } from "./CoursesIcon.vue?vue&type=template&id=9484b046&scoped=true&"
var script = {}
import style0 from "./CoursesIcon.vue?vue&type=style&index=0&id=9484b046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9484b046",
  null
  
)

export default component.exports